/* Tuplas a Catálogos  -  Catálogo a Tuplas
   Se recibe un objeto tipo tupla que se convierte a un arreglo tipo catálogo y viceversa (ejemplo con archivos estáticos)
*/

//*datos
import tuplaArch from "../../../datos/json/tupla.json";
import catalogoArch from "../../../datos/json/catalogo.json";

//*clases
import "../componentes.css"

//*archivos
import ConvierteTuplaACatalogo from "../../../componentes/ConvierteTuplaACatalogo";
import ConvierteCatalogoATupla from "../../../componentes/ConvierteCatalogoATupla";

//*componente
export default function Ejemplo(){
let tupla=tuplaArch;
let catalogo=catalogoArch;
    return (
      <div className="container container-Vista" >
          <h1>Ejemplo  de tupla a catálogo</h1>
         

          <label >
              Ejemplo con un archivo insumo en data/tupla.json  <br/>
              objeto de 32 elementos en tuplas:<i><b> "2": "Aguascalientes",  ... , "2431": "Zacatecas"</b></i> <br/>
              Se espera un arreglo con 32 objetos con el formato:<i><b> 'id': '2', 'desc': 'Aguascalientes' ...  id': '2431', 'desc': 'Zacatecas'</b></i>
           </label>

           <div className="container-Componente" >
              <ConvierteTuplaACatalogo  tupla={tupla} />
           </div>

          <br/> <br/>


          <h1>Ejemplo  de catálogo a tupla</h1>

          <label>
              Ejemplo con un archivo insumo en data/catalogo.json  <br/>
              Arreglo con 32 objetos:<i><b> 'id': '2', 'desc': 'Aguascalientes' ...  id': '2431', 'desc': 'Zacatecas'</b></i><br/>
              Se espero un objeto con tuplas:<i><b> "2": "Aguascalientes",  ... , "2431": "Zacatecas"</b></i> <br/>
           </label>

           <div className="container-Componente" >
             <ConvierteCatalogoATupla catalogo= {catalogo} />
           </div> 

          <br/>
      </div>
    );
}
